import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "dropdown"];
  static values = { users: Array };

  initialize() {
    this.boundClickOutside = this.clickOutside.bind(this);
    this.boundKeydown = this.keydown.bind(this);
  }

  connect() {
    document.addEventListener("click", this.boundClickOutside);
    document.addEventListener("keydown", this.boundKeydown);
    this.render();
  }

  disconnect() {
    document.removeEventListener("click", this.boundClickOutside);
    document.removeEventListener("keydown", this.boundKeydown);
  }

  open() {
    this.render();
    this.dropdownTarget.hidden = false;
  }

  close() {
    this.dropdownTarget.hidden = true;
  }

  toggle(event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.dropdownTarget.hidden) {
      this.inputTarget.focus();
      this.open();
    } else {
      this.close();
    }
  }

  filter() {
    this.render();
    this.dropdownTarget.hidden = false;
  }

  pick(event) {
    const value = event.currentTarget.dataset.userAutocompleteValue;
    this.inputTarget.value = value;
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }));
    this.close();
    this.inputTarget.focus();
  }

  render() {
    const users = this.usersValue || [];
    const query = (this.inputTarget.value || "").toLowerCase().trim();
    const filtered = query
      ? users.filter((u) => this.match(u, query))
      : users;

    if (filtered.length === 0) {
      this.dropdownTarget.innerHTML =
        '<div class="autocomplete-empty">No estate users match — your text will be saved as free form.</div>';
      return;
    }

    this.dropdownTarget.innerHTML = filtered
      .map((u) => this.optionMarkup(u))
      .join("");
  }

  optionMarkup(user) {
    const value = this.escape(user.value || "");
    const hint = user.hint && user.hint !== user.value ? this.escape(user.hint) : "";
    const hintMarkup = hint ? `<span class="autocomplete-hint">${hint}</span>` : "";
    return `
      <button type="button" class="autocomplete-option"
              data-action="click->user-autocomplete#pick"
              data-user-autocomplete-value="${value}">
        <strong>${value}</strong>${hintMarkup}
      </button>
    `;
  }

  match(user, query) {
    return (
      (user.value || "").toLowerCase().includes(query) ||
      (user.hint || "").toLowerCase().includes(query)
    );
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) this.close();
  }

  keydown(event) {
    if (event.key === "Escape" && !this.dropdownTarget.hidden) {
      this.close();
    }
  }

  escape(s) {
    return String(s).replace(/[&<>"']/g, (c) => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
    }[c]));
  }
}
